// extracted by mini-css-extract-plugin
export default {"list":"poster-editor-fancytext-shape-panel-module__list--eu0TQ"};